import { Popup as MapboxPopup } from 'react-map-gl'
import { type FetchedPlot } from '#app/types'
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'

export type PopupContent = {
	latitude: number
	longitude: number
	handle: FetchedPlot['handle']
	note: FetchedPlot['note']
	user: FetchedPlot['user']
}

export const Popup = ({
	popupContent,
	onClose,
}: {
	popupContent: PopupContent | null
	onClose: () => void
}) => {
	if (!popupContent) return null

	return (
		<MapboxPopup
			longitude={popupContent.longitude}
			latitude={popupContent.latitude}
			onClose={onClose}
			closeButton={false}
			anchor="bottom-left"
		>
			<div className="flex flex-col gap-1 font-sans text-xs">
				<h2 className="text-sm font-semibold">{popupContent.handle}</h2>
				{popupContent.note && (
					<p
						className="text-sm"
						style={{
							wordBreak: 'break-word',
						}}
					>
						{popupContent.note}
					</p>
				)}
				<div className="flex items-center gap-1 text-xs">
					Owned by
					<Avatar className="h-5 w-5">
						<AvatarImage
							src={popupContent.user.imageUrl ?? ''}
							className="flex h-full w-full items-center justify-center rounded-full bg-background object-cover"
						/>
						<AvatarFallback className="text-xs uppercase">
							{popupContent.user.handle.slice(0, 1)}
						</AvatarFallback>
					</Avatar>
					{popupContent.user && <span>{popupContent.user.handle}</span>}
				</div>
			</div>
		</MapboxPopup>
	)
}
